import React, { useEffect, useState } from "react";
import { isEmpty } from "../../common/cores";
import { withRouter } from "react-router-dom";
const MobileStickyFootbar = (props) => {
  const [activeTab, setActiveTab] = useState("home");
  const { location } = props;
  const tabs = [
    {
      key: "a",
      label: isEmpty(window.lang["입금"]) ? "입금" : window.lang["입금"],
      icon: "/images/upload/mobile/vip_btm_depowithdrawl.png",
      path: "/deposit",
    },
    {
      key: "deposit",
      label: isEmpty(window.lang["출금"]) ? "출금" : window.lang["출금"],
      icon: "/images/upload/mobile/vip_btm_depowithdrawl.png",
      path: "/withdraw",
    },
    {
      key: "bettingHistory",
      label: isEmpty(window.lang["베팅내역"])
        ? "베팅내역"
        : window.lang["베팅내역"],
      icon: "/images/upload/mobile/vip_btm_inquiry.png",
      path: "/mypage/history",
    },
    {
      key: "event",
      label: isEmpty(window.lang["이벤트"]) ? "이벤트" : window.lang["이벤트"],
      icon: "/images/upload/mobile/vip_btm_coupon.png",
      path: "/events",
    },
    {
      key: "question",
      label: isEmpty(window.lang["1:1문의"])
        ? "1:1문의"
        : window.lang["1:1문의"],
      icon: "/images/upload/mobile/vip_btm_livehat.png",
      path: "/inquiries/question",
    },
  ];

  useEffect(() => {
    setActiveTab(location.pathname);
  }, [location]);

  return (
    <div className="bottom-tab-bar">
      {tabs.map((tab) => (
        <div
          key={tab.key}
          className={`tab-item ${
            location.pathname === tab.path ? "active" : ""
          }`}
          onClick={() => {
            window.location.href = tab.path;
          }}
        >
          <img src={tab.icon} alt={tab.label} className="tab-icon" />
          <div
            className="tab-label"
            style={{ color: "#fff", fontWeight: "bolder" }}
          >
            {tab.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default withRouter(MobileStickyFootbar);



// WEBPACK FOOTER //
// ./src/components/Layout/MobileStickyFootbar.js